/**
 * @description: 用户认证
 * @param {type} 
 * @return: 
 */
<template>
  <div class="flex column space-between">
    <div class="main-wraper">
      <i class="icon-delete r_delete fa fa-close" @click="back"/></i>

      <div class="welcome">
        <p>
          <img src="@/assets/imgs/auth/r_img.png" alt>
        </p>
        <!-- 标题写在路由模块下 -->
        <h1>{{$route.meta.title || ''}}</h1>
      </div>
      <div class="input-outer">
        <div class="input_label flex itemCenter">
          <img src="@/assets/imgs/auth/r_account.png">
          <input type="tel" placeholder="请输入手机号" class="flex1" v-model="Auth.mobile">
          <img src="@/assets/imgs/auth/r_shanchu.png" @click="Auth.mobile = null" alt>
        </div>
        <div class="input_label flex itemCenter" v-show="Auth.loginType">
          <img src="@/assets/imgs/auth/r_passwd.png">
          <input type="password" placeholder="请输入密码" v-model="Auth.customerPwd" class="flex1">
        </div>
        <div class="input_container" v-show="!Auth.loginType">
          <div class="input_label flex itemCenter">
            <img src="@/assets/imgs/auth/r_yzm.png">
            <input
              type="number"
              placeholder="请输入收到的验证码"
              v-model="Auth.smsCode"
              class="flex1"
              maxl="10000"
            >
          </div>
          <div>
            <span
              class="spotCode"
              @click="randomCode"
              v-show="Auth.waitTime==60||!Auth.waitTime"
            >获取验证码</span>
            <span class="waitTime" v-show="Auth.waitTime<60">{{Auth.waitTime}}</span>
          </div>
        </div>
        <div class="register" @click="signIn(redirect)">登录</div>
        <div class="signin_type_btn flex space-between">
          <!-- <span v-show="!Auth.loginType" @click="Auth.loginType = !Auth.loginType">密码登录</span> -->
          <span v-show="Auth.loginType" @click="Auth.loginType = !Auth.loginType">验证码登录</span>
           
        </div>
         
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { ROOT_REQUEST } from "@/assets/configs";

export default {
  name: "SignIn",
  data() {
    return {
      openId: null,
      redirect: null
    };
  },
  computed: {
    ...mapState({
      Auth: state => state.Auth,
      goback: state => state.goback
    })
  },
  methods: {
    ...mapActions("Auth", ["randomCode", "signIn", "wechatSignIn"]),
    ...mapMutations("Auth", ["checkPwdCode"]),
    getUserInfoFromUrl() {
      let userInfo = this.getUrlParams().userInfo;
      if (userInfo) {
        //用户信息
        localStorage.setItem("userInfo", userInfo);
        userInfo = JSON.parse(userInfo);
        for (let key of Object.keys(userInfo)) {
          let value = typeof userInfo[key] == "string" ? userInfo[key] : JSON.stringify(userInfo[key]);
          localStorage.setItem(key, value);
        }
        //小程序名
        sessionStorage.setItem("fromMini", this.getUrlParams().fromMini);
        //其他项目存储的字段
        localStorage.setItem("userId", "Bearer" + " " + userInfo.authorization);
        localStorage.setItem("authorization", userInfo.authorization);
        localStorage.setItem("baserole", userInfo.role);
        localStorage.setItem("account", userInfo.mobile);
        localStorage.setItem("petroleumAccount", userInfo.mobile);
        localStorage.setItem("petroleumAuthor", userInfo.authorization);
        sessionStorage.setItem("userId", "Bearer" + " " + userInfo.authorization);

        //区分小程序来源
        if (this.$route.query.useCompany) {
          localStorage.setItem("useCompany", this.$route.query.useCompany);
          sessionStorage.setItem("useCompany", this.$route.query.useCompany);
        }
        if (sessionStorage.getItem("useCompany") == "hdzxcc") {
          sessionStorage.setItem("parkCode", "1383");
        }
        if (sessionStorage.getItem("useCompany") == "hyzxcc") {
          sessionStorage.setItem("parkCode", "1002");
        }
        if (sessionStorage.getItem("useCompany") == "byzxcc") {
          sessionStorage.setItem("parkCode", "1000");
        }
        if (sessionStorage.getItem("useCompany") == "linanzxcc") {
          sessionStorage.setItem("parkCode", "1000");
        }
        if (sessionStorage.getItem("useCompany") == "ywglg") {
          sessionStorage.setItem("parkCode", "1631");
        }

        location.href = ROOT_REQUEST.web_base + "h5/specialline/#" + localStorage.getItem("zxRedirction");
      }
    },
    back() {
      if (this.$route.query.isautoLogin == 1) {
        location.href = ROOT_REQUEST.web_base + "h5/specialline/#" + localStorage.getItem("zxRedircet");
      } else {
        history.go(-1);
      }
    }
  },
  created() {
    this.checkPwdCode();
    let { openId = null, redirect } = this.$route.query;
    this.openId = openId;
    this.redirect = redirect;
  },
  mounted() {
    var vm = this;
    //判断是否是小程序自动登录返回
    if (this.$route.query.isautoLogin == 1) {
      this.getUserInfoFromUrl();
    } else {
    }
  }
};
</script>
<style lang="scss">
@import "./login";
</style>